var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0428\\u0430\\u0440_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#New_gradient_1-3);}.cls-2{fill:#0315e7;}.cls-3{fill:url(#New_gradient_1);}.cls-4{fill:url(#New_gradient_1-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_gradient_1",
    x1: 155.65,
    y1: 605.66,
    x2: 155.65,
    y2: 173.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0315e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1b2ae6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#323ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#3f48e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#444ce6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_gradient_1-2",
    x1: 300,
    y1: 608.01,
    x2: 300,
    y2: 123.97,
    xlinkHref: "#New_gradient_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_gradient_1-3",
    x1: 444.35,
    y1: 608.7,
    x2: 444.35,
    y2: 109.33,
    xlinkHref: "#New_gradient_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0428\\u0430\\u0440_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m300,19.06c15.54,0,31.08,5.93,42.93,17.78l220.26,220.26c23.71,23.71,23.71,62.15,0,85.86l-220.26,220.26c-11.86,11.86-27.39,17.78-42.93,17.78s-31.08-5.93-42.93-17.78L36.81,342.97c-23.71-23.71-23.71-62.15,0-85.86L257.07,36.84c11.86-11.86,27.39-17.78,42.93-17.78m0-19.06c-21.31,0-41.34,8.3-56.41,23.37L23.33,243.63c-31.1,31.11-31.1,81.72,0,112.82l220.26,220.26c15.07,15.07,35.1,23.37,56.41,23.37s41.34-8.3,56.41-23.37l220.26-220.26c31.1-31.11,31.1-81.72,0-112.82L356.41,23.37c-15.07-15.07-35.1-23.37-56.41-23.37h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "93.58 307.76 93.58 399.74 217.71 523.88 217.71 307.76 93.58 307.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m237.93,161.58v382.52l19.14,19.14c23.71,23.71,62.15,23.71,85.86,0l19.14-19.14V161.58h-124.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "382.29 15.19 382.29 523.88 506.42 399.74 506.42 15.19 382.29 15.19"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo-new.9c01c14832300e3effd85ce83fea2b58.svg";
export { ForwardRef as ReactComponent };